import dayjs, { Dayjs, OpUnitType, QUnitType } from 'dayjs'
import 'dayjs/locale/ko'

const now = () => dayjs().locale('ko')
const A_HOUR = 24
const SECONDS_IN_A_MINUTES = 60
const SECONDS_IN_A_HOUR = 3600
const SECONDS_IN_A_DAY = A_HOUR * SECONDS_IN_A_HOUR

export type DateFormatType =
  | 'YY.MM.DD'
  | 'YY-MM-DD'
  | 'YY/MM/DD'
  | 'YYYY/MM/DD'
  | 'YYYY.MM.DD'
  | 'YYYY년 MM월 DD일'
  | 'YYYYMMDDHHmmss'
  | 'YYMMDD'
  | 'YYYY-MM-DD'

const removeDateStringTZ = (date: string) =>
  dayjs(date.replace(/-/g, '/').replace('T', ' ').replace('Z', ' '))

const DateFormat = (date: string | Dayjs, format: DateFormatType): string => {
  if (!date) return ''
  const targetDate = typeof date === 'string' ? removeDateStringTZ(date) : date

  return targetDate?.format(format)
}

function getDayDifference(date: string | Dayjs, unit: QUnitType | OpUnitType): string {
  if (!date) return '0'
  const targetDate = typeof date === 'string' ? removeDateStringTZ(date) : date
  const nowDate = unit === 'days' ? DateFormat(now(), 'YYYY-MM-DD') : now()
  const difResultValue = targetDate.locale('ko').diff(nowDate, unit)
  return difResultValue === 0 ? 'DAY' : `${difResultValue}`
}

function timeFormatter(count: number) {
  const days = Math.floor(count / SECONDS_IN_A_DAY)

  const remainingSeconds = count % SECONDS_IN_A_DAY
  const hours = Math.floor(remainingSeconds / SECONDS_IN_A_HOUR)
  const minutes = Math.floor((remainingSeconds % SECONDS_IN_A_HOUR) / SECONDS_IN_A_MINUTES)
  const seconds = remainingSeconds % SECONDS_IN_A_MINUTES

  const formattedDays = `${days < 10 && '0'}${days}`
  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = minutes.toString().padStart(2, '0')
  const formattedSeconds = seconds.toString().padStart(2, '0')

  if (days >= 1) {
    return `${formattedDays}`
  } else {
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
  }
}

export const DateUtils = {
  timeFormatter,
  getDayDifference,
  now,
}
